const isProd = process.env.NODE_ENV === 'production'
module.exports = {
	baseUrl: isProd ? 'https://console.mopaas.com/oapi/get/':'api/'
}


//////////////////
// WEBPACK FOOTER
// ./config/api.config.js
// module id = mrgY
// module chunks = 0